__turbopack_context__.v({
  "grid": "Grid-module-scss-module__ew9pEW__grid",
});
